import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "list-group-item" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-auto fw-bold"
}
const _hoisted_4 = {
  key: 1,
  class: "col-auto text-muted"
}

import { ICardInfo } from '@/interfaces';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreditCardPaymentItem',
  props: {
    info: {}
  },
  setup(__props: any) {

const emit = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col" }, [
        _createElementVNode("h4", { class: "mb-0" }, " Cartão de crédito ")
      ], -1)),
      (_ctx.info)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " **** " + _toDisplayString(_ctx.info?.card_last_digits), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, " Nenhum "))
    ])
  ]))
}
}

})